import { useQuery } from '@tanstack/react-query';
import type { LibraryCategory, LibraryDrill, LibraryLevel } from '@hoopify/shared';
import { api } from './api';

/** The Hoopify library rarely changes, so fetch it once per visit. */
export function useLibrary() {
  return useQuery({ queryKey: ['library'], queryFn: () => api.get<LibraryDrill[]>('/library/drills'), staleTime: Infinity });
}

export interface LibraryFilter {
  q?: string;
  category?: LibraryCategory | null;
  level?: LibraryLevel | null;
  /** Players you have: hides drills that need more. */
  players?: number | null;
}

export function filterLibrary(list: LibraryDrill[], f: LibraryFilter) {
  const q = f.q?.trim().toLowerCase();
  return list.filter(
    (d) =>
      (!f.category || d.category === f.category) &&
      // "All ages" drills suit everyone, so they show for either level.
      (!f.level || d.level === f.level || d.level === 'all') &&
      (!f.players || !d.minPlayers || d.minPlayers <= f.players) &&
      (!q || `${d.title} ${d.summary} ${d.description} ${d.coachingPoints} ${d.tags.join(' ')}`.toLowerCase().includes(q)),
  );
}
